import { render, staticRenderFns } from "./SectionFishing.vue?vue&type=template&id=2f00fadb&scoped=true&"
import script from "./SectionFishing.vue?vue&type=script&lang=js&"
export * from "./SectionFishing.vue?vue&type=script&lang=js&"
import style0 from "./SectionFishing.vue?vue&type=style&index=0&id=2f00fadb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f00fadb",
  null
  
)

export default component.exports